module.exports = __webpack_public_path__ + "img/red-contra-incendios.4c79a617.jpg";